import React from "react";
import { CompleoDynamicDashboardPage } from "customHooks/useDynamicDashboard";
import DynamicDashboardItems from "../DynamicDashboard/DynamicDashboardItems";

const DashboardJobs = (props: any) => {
    const module = "APPLICANTDASHBOARD";

    return (
        <CompleoDynamicDashboardPage
            moduleName={module}
            listApiAddress="/reports/applicantdynamicdashboard"
        >
            <DynamicDashboardItems dashboardName={module} />
        </CompleoDynamicDashboardPage>
    );
};

export default DashboardJobs;
